import styled from 'styled-components';

import FadeDiv from '@/components/Common/FadeDiv';
import FeedbackStaticModal from '@/features/Feedback/components/FeedbackStaticModal';
import type {
  DETAIL_MODAL_TYPE,
  DetailModalOptions,
} from '@/stores/pure/DetailModalStore';
import { detailModalStyle } from '@/styles/style';

type Props = {
  alias: string;
  pos: number;
  options: DetailModalOptions<{
    focusedBlock?: string;
  }>;
  closeModal: () => void;
  onSelectNewModal: (alias: string, type: DETAIL_MODAL_TYPE) => void;
};

const StaticFeedbackModal = (props: Props) => {
  return (
    <ModalStyle status={true} pos={props.pos}>
      <FeedbackStaticModal.Header
        closeModal={props.closeModal}
        feedbackAlias={props.alias}
      />
      <FeedbackStaticModal.Body
        feedbackAlias={props.alias}
        focusedBlock={props.options?.focusedBlock}
        style={{
          maxHeight: 'calc(100vh - 56px)',
        }}
      />
    </ModalStyle>
  );
};

const ModalStyle = styled(FadeDiv)<{ pos: number }>`
  position: fixed;
  width: 600px;
  height: 100vh;
  top: 0;
  right: ${({ pos }) => pos}px;
  ${detailModalStyle}
`;

export default StaticFeedbackModal;
